module.exports = __webpack_public_path__ + "static/media/06b.396f3cfa.png";